import { createFileRoute } from '@tanstack/react-router';

import { DeviceCheck } from '#modules/user/features/profile/components/Settings/DeviceCheck';
import type { CheckEntry } from '#features/media/deviceCheckReport';

/**
 * Откуда человек пришёл. В отчёте это половина смысла: прогон из настроек - это профилактика, а
 * прогон по ссылке из разговора - человек уже уткнулся в проблему, и починилось ли у него, важнее
 * всего остального.
 */
const ENTRIES: CheckEntry[] = ['settings', 'call', 'voice', 'onboarding'];

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/settings/_settings/devices'
)({
  validateSearch: (search: Record<string, unknown>): { from?: CheckEntry } => {
    const from = search.from;
    return typeof from === 'string' && ENTRIES.includes(from as CheckEntry)
      ? { from: from as CheckEntry }
      : {};
  },
  component: DeviceCheckRoute,
  ssr: false,
});

function DeviceCheckRoute() {
  const { from } = Route.useSearch();
  return <DeviceCheck entry={from ?? 'settings'} />;
}
